import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { AddInvolvedEmployeesCommand } from './add-involved-employees.command';

/**
 * Add involved employees use case.
 * Adds employees to the involved employees list for a case (bulk operation).
 */
@Injectable({ providedIn: 'root' })
export class AddInvolvedEmployeesUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  /**
   * Executes the add involved employees use case.
   * @param command - The command containing case ID and employee IDs to add
   * @returns Observable void
   */
  public execute(command: AddInvolvedEmployeesCommand): Observable<void> {
    this._state.setSavingCases(true);
    this._state.setErrorCases(null);

    return this._repository.addInvolvedEmployees(command.caseId, command.employeeIds).pipe(
      tap(() => {
        this._state.setSavingCases(false);
      }),
      catchError((error) => {
        this._state.setErrorCases(error.message || 'Failed to add involved employees');
        this._state.setSavingCases(false);
        return throwError(() => error);
      })
    );
  }
}
